import { Component } from "react";
import './About.css';
import Plan from '../images/success-strategy.png';
import Focused from '../images/focused-solutions.png';
import Partners from '../images/wilogics2.jpg';

class About extends Component {
    render() {
        return (
            <div className="About">
                <p className="intro-statement">
                    The impact of technology has significantly affected not only the way businesses operate but the way we live our lives. The reality is that businesses do not exist in a vacuum, they have to adapt to the rapidly changing market conditions.
                </p>
                <div className="plan">
                    <img alt="success strategy plan" src={Plan} />
                    <p>Companies do not plan to fail they fail to plan. ANA IT Solutions Inc. can help you plan ahead, utilising evolving technologies to improve business processes and maintain a competitive edge in the ever-changing marketplace.</p>
                </div>
                <div className="focused">
                    <img alt="focused plan" src={Focused} />
                    <p>We recognise that every business is different. ANA IT Solutions Inc. offers Intelligent Business Solutions not "standard solutions" focusing on strategic initiatives. We get to the root of your individual and unique requirements, and then recommend an appropriate solution, in line with your objectives and constraints.</p>
                </div>
                <div className="partners">
                    <h4>Our Partners</h4>
                    <img alt="Wi-Logix" src={Partners} title="Wi-Logix Project Management"/>
                </div>
            </div>
        );
    }
}

export default About;